import { useEffect, useRef } from "react";
import { toastError, toastSuccess } from "../utils/toastUtils";

const useOnlineStatus = () => {
  const wasOnline = useRef(navigator.onLine);

  useEffect(() => {
    const handleStatusChange = () => {
      const currentStatus = navigator.onLine;
      if (wasOnline.current !== currentStatus) {
        if (currentStatus) {
          toastSuccess("You are back online");
        } else {
          toastError("You are offline");
        }
        wasOnline.current = currentStatus;
      }
    };

    window.addEventListener("online", handleStatusChange);
    window.addEventListener("offline", handleStatusChange);

    return () => {
      window.removeEventListener("online", handleStatusChange);
      window.removeEventListener("offline", handleStatusChange);
    };
  }, []);

  return wasOnline.current;
};

export default useOnlineStatus;
